export default __webpack_public_path__ + "static/media/1809.96bfd383.png";